import { FunctionComponent } from "react";
import { Box, Text } from "@chakra-ui/react";

import { Button } from "src/components";

import EmptyStateImage from "src/assets/images/empty_state_.png";

type Props = {
  label: string;
  btnLabel?: string;
  handleClick?: any;
  description?: string;
  btnSize?: any;
  height?: string;
};

export const EmptyState: FunctionComponent<Props> = ({
  label,
  btnLabel,
  description,
  handleClick,
  btnSize,
  height,
}) => {
  return (
    <Box
      height={height || "100vh"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      width={"50%"}
      m={"auto"}
      textAlign={"center"}
    >
      <img src={EmptyStateImage} width={"250px"} height={"250px"} />
      <Box mt={2} mb={4} textAlign={"center"}>
        <Text fontSize={"14px"} color={"primary"} fontWeight={500}>
          {label}
        </Text>
        <Text
          fontSize={"12px"}
          color={"primary"}
          fontWeight={300}
          w={"70%"}
          m={"auto"}
        >
          {description}
        </Text>
      </Box>
      {btnLabel && (
        <Button
          label={btnLabel}
          handleClick={handleClick}
          size={btnSize || "md"}
        />
      )}
    </Box>
  );
};
